import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// Light / Dark theme layer: must load after index.css so its .dark rules follow Tailwind's utilities.
import "@/styles/theme.css";
import { ThemeProvider } from "next-themes";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* Light is the default and today's look. Dark is opt-in per browser; next-themes keeps the
        choice in localStorage ("theme") and sets class="dark" on <html> before first paint. */}
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
